import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { resetPasswordActions } from "redux/actions/auth/ResetPassword/resetPasswordActions";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";

interface resetPasswordTypes {
  password: string;
  confirmPassword: string;
}

export const useResetPasswordFormik = (
  setResetPop: any,
  resetPasswordMethod: any,
  phoneNum: any,
  email: any
) => {
  const dispatch: any = useDispatch();
  const { t, i18n } = useTranslation();

  const { resetUserId } = useSelector(
    (state: RootState) => state.validateOtpResetPasswordReducer
  );

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: yup.object({
      password: yup
        .string()
        .min(8, `${t("password must be at least 8 characters long")}`)
        .matches(
          new RegExp(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*-_?&#]{8,}$/
          ),
          `${t("must contain lowercase, uppercase letter, one number")}`
        )
        .required(`${t("This field is required")}`),
      confirmPassword: yup
        .string()
        .min(8, `${t("password must be at least 8 characters long")}`)
        .oneOf([yup.ref("password")], `${t("Passwords dosen't match")}`)
        .required(`${t("This field is required")}`),
    }),
    onSubmit: async (values: resetPasswordTypes) => {
      await dispatch(
        resetPasswordActions(
          {
            id: resetUserId,
            password: formik.values.confirmPassword,
          },
          () => {
            setResetPop("");
          }
        )
      );
    },
  });

  return formik;
};
